import { render, staticRenderFns } from "./child-task-guanli.vue?vue&type=template&id=0538bbde&scoped=true&"
import script from "./child-task-guanli.vue?vue&type=script&lang=ts&"
export * from "./child-task-guanli.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0538bbde",
  null
  
)

export default component.exports